// extracted by mini-css-extract-plugin
export var errorIcon = "_nr-1";
export var nameLogo = "_nr-0";